export default "__VITE_ASSET__BGgawuLq__"